import { forwardRef } from 'react';
import Card from "@/components/Card";
import ScrollableContainer from "@/components/ScrollableContainer";
import background1 from "@/assets/images/polish-car-4.jpeg";
import background2 from "@/assets/images/fabric-cleaning.jpeg";
import background3 from "@/assets/images/aircond-service.jpeg";
import background4 from "@/assets/images/sanitise-bg-2.jpeg";
import background5 from "@/assets/images/pest-control-bg.jpeg";
import { useTranslation } from 'react-i18next';

const Services = forwardRef<HTMLElement>((_, ref) => {
  const { t } = useTranslation();

  return (
    <section ref={ref} id="services" className="min-h-screen flex flex-col py-16 md:px-[90px]">
      <h1 className="flex justify-center">{t('services.title')}</h1>
      <p className="text-center text-gray-500 text-xs md:text-sm mb-4 mt-2 px-4">{t('services.clickForMore')}</p>

      <div className="flex-1 overflow-hidden">
        <ScrollableContainer className="h-full py-4" scrollAmount={350}>
          <div className="flex flex-nowrap gap-4 px-4 md:px-0">
            <Card image={background1} text={t('services.carPolish')} serviceId="car-polish" />
            <Card image={background2} text={t('services.fabricCleaning')} serviceId="fabric" />
            <Card image={background3} text={t('services.aircond')} serviceId="aircond" />
            <Card image={background4} text={t('services.sanitise')} serviceId="sanitise" />
            <Card image={background5} text={t('services.pestControl')} serviceId="pest-control" />
          </div>
        </ScrollableContainer>
      </div>
    </section>
  );
});

export default Services;
